import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import { useLocation, useSearchParams } from 'react-router-dom'
import { BrchUsrMaster } from '../../common/constants'
import UserMaster from './UserMaster'
import BranchMaster from './BranchMaster'
import UserRollRights from './UserRollRights'
import MavenManagement from './MavenManagement'
import AutoDeactivateUser from './AutoDeactivateUser'
import MacDetailes from './MacDetailesTab/MacDetailes'
import { findObjctByValueFromArrayOfObject } from '../../common/helper'
import useToken from '../../helpers/useTokens'
import { decryptText } from '../../common/loginDecode'
import { setRollRightsData, updateAlertError, updateLoader } from '../../../store/common/common_action'
import { connect, useDispatch } from 'react-redux'
import { userRollRightEditRights } from '../../../store/branchAndUserMaster/BUMAction'
import { CrewMaster } from './CrewMaster'
const BranchAndUserMaster = (props) => {
    const { userRollRightEditRights, updateLoader } = props
    const [searchParams, setSearchParams] = useSearchParams()
    const dispatch = useDispatch()
    const location = useLocation();
    const shouldHide =
        location.search.includes('&data=');

    let loginData = {}
    const { loginData: loginDataTemp } = useToken()
    if (searchParams.get('data')) {

        const data = searchParams.get('data')
        const loginDataTemp = data.split('||')
        const cleanedData = loginDataTemp[0].replace(/\s+/g, '+');
        const decryptData = decryptText(cleanedData)
        if (decryptData) {
            loginData = JSON.parse(decryptData)
            loginData.BusCrsCheckSum = loginDataTemp[1]
        }
    } else {
        loginData = loginDataTemp
    }
    const { intCompanyID, intBranchID, intUserID, BusCrsCheckSum, strCompanyName, strUserName, intRoleID } = loginData
    const [masterNumber, setMasterNumber] = useState(Number(searchParams.get('tab')) || "")
    const [allTabs, setAllTabs] = useState([])
    const tabsList = [{ JobID: 21, name: "Branch Master" }, { JobID: 31, name: "User Master" }, { JobID: 13, name: "Crew Master" }, { JobID: 26, name: "User Role Rights" }, { JobID: 4, name: "Mac Details" },
    { JobID: 428, name: "Maven Management" }, { JobID: 413, name: "Auto De-Activate Users" }]
    const visibleTabsList = shouldHide ? tabsList.filter((item) => item.JobID !== 13) : tabsList
    useEffect(() => {
        if (shouldHide && loginData?.intRoleID !== 'undefined') {
            const obj = {
                RoleID: loginData?.intRoleID,
                IsLuggage: 0,
            };
            const fetchRollRights = async () => {
                dispatch(updateLoader(true));
                try {
                    const res = await userRollRightEditRights(obj);
                    if (res.status === 'Success') {
                        dispatch(setRollRightsData(res.Data));
                        sessionStorage.setItem('token1', JSON.stringify(res.Data.Table));
                        setAllTabs(res.Data.Table || []);
                        if (masterNumber === '' || (shouldHide && Number(masterNumber) === 13)) {
                            const newData = visibleTabsList.filter((item) => item.JobID !== 4 ? findObjctByValueFromArrayOfObject(res.Data.Table, item.JobID, 'JobID', "IsActive") === 1 ? item : null : item)
                            goToTabs(newData?.[0]?.JobID)
                        }
                        dispatch(updateLoader(false));
                    } else {
                        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }));
                        dispatch(setRollRightsData([]))
                        setAllTabs([]);
                    }
                } catch (error) {
                    dispatch(updateLoader(false));
                    dispatch(updateAlertError({ show: true, msg: error.message || 'Something went wrong', nextId: '' }));
                    dispatch(setRollRightsData([]));
                }
            };
            fetchRollRights();
        } else {
            const allGSPages = sessionStorage.getItem('token1');
            const allGSPagesActive = JSON.parse(allGSPages);
            if (allGSPagesActive?.length > 0) {
                setAllTabs(allGSPagesActive)
            } else {
                setAllTabs([])
            }
            if (masterNumber === '' || (shouldHide && Number(masterNumber) === 13)) {
                const newData = visibleTabsList.filter((item) => item.JobID !== 4 ? findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null : item)
                goToTabs(newData?.[0]?.JobID)
            }
        }
    }, [searchParams, loginData?.intRoleID])
    const params = {}
    for (let entry of searchParams.entries()) {
        params[entry[0]] = entry[1]
    }
    const goToTabs = (lrTab) => {
        params.tab = lrTab
        setSearchParams(params)
        setMasterNumber(lrTab)
    }
    // const tabsList = [{ id: 1, name: "Branch Master" }, { id: 2, name: "User Master" }, { id: 3, name: "User Role Rights" }, { id: 4, name: "Mac Details" },
    // { id: 5, name: "Maven Management" }, { id: 413, name: "Auto De-Activate Users" }]

    const contentShow = (key) => {
        let MasterTab
        switch (key) {
            case 21: {
                MasterTab = <BranchMaster loginData={loginData} FromUrlRedirect={shouldHide} />
                break
            }
            case 31: {
                MasterTab = <UserMaster loginData={loginData} />
                break
            }
            case 13: {
                MasterTab = shouldHide ? '' : <CrewMaster />
                break
            }
            case 26: {
                MasterTab = <UserRollRights loginData={loginData} />
                break
            }
            case 4: {
                MasterTab = <MacDetailes loginData={loginData} />
                break
            }
            case 428: {
                MasterTab = <MavenManagement loginData={loginData} />
                break
            }
            case 413: {
                MasterTab = <AutoDeactivateUser loginData={loginData} />
                break
            }
            default:
                MasterTab = ''
                break
        }
        return MasterTab
    }
    return (
        <>
            {shouldHide && (
                <style>
                    {`
            .header-toolbar {
              display: none !important;
            }
          `}
                </style>
            )}
            <Box className='brnchUsrMaster'>
                {
                    visibleTabsList?.map((val, i) =>
                        <Button key={i} className={`brnchUsrMasterBtn ${masterNumber == val.JobID ? 'active' : ''}`} variant="outlined" onClick={() => goToTabs(val.JobID)}
                            sx={{
                                display:
                                    val.JobID !== 4 ? findObjctByValueFromArrayOfObject(allTabs, val.JobID, 'JobID', "IsActive") === 1
                                        ? 'inline-block'
                                        : 'none' : 'inline-block',
                            }}
                        >{val.name}</Button>
                    )
                }
            </Box>
            <Box>
                {contentShow(masterNumber)}
            </Box>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { userRollRightEditRights, updateLoader }
export default connect(mapStateToProps, mapDispatchToProps)(BranchAndUserMaster)
//export default BranchAndUserMaster
